import API from '@/services/api.js'

const actions = {
  set_loading({commit}, value) {
    commit('SET_LOADING', value)
  },
  setInitialized({commit}, value) {
    commit('SET_INITIALIZED', value)
  },
  setApiVersion({commit}, value) {
    return API.getVersion()
      .then(res => {
        return commit('SET_API_VERSION', res.data.version)
      })
      .catch(error => {
        console.log('Store - failed to get user: ' + error)
        return commit('SET_API_VERSION', 0)
      })
  },
  setLocale({commit}, value) {
    console.log('setLocale ', value)
    commit('SET_LOCALE', value)
    localStorage.setItem('locale', value)
    // RFC 7231, section 5.3.5
    API.setHeaders('Accept-Language', value)
  }
}

export default actions
